import { AppMenuItem } from '@shared/layouts/cerema-layout/models/app-menu.item';

export const APP_MENU: AppMenuItem[] = [
    {
        label: 'Abonnements',
        icon: 'pi pi-bookmark-fill',
        items: [
            {
                label: 'Tableau de bord',
                icon: 'pi pi-chart-bar',
                routerLink: ['/dashboard']
            },
            {
                label: 'Applications',
                icon: 'pi pi-th-large',
                routerLink: ['/applications'],
                roles: ['ROLE_APP_ADMIN']
            },
            {
                label: 'Offres',
                icon: 'pi pi-tags',
                routerLink: ['/offers'],
                roles: ['ROLE_APP_ADMIN']
            },
            {
                label: 'Organismes',
                icon: 'pi pi-building',
                routerLink: ['/organizations'],
                roles: ['ROLE_APP_ADMIN', 'ROLE_ORG_ADMIN']
            },
            {
                label: 'Souscriptions',
                icon: 'pi pi-id-card',
                routerLink: ['/subscriptions'],
                roles: ['ROLE_APP_ADMIN', 'ROLE_ORG_ADMIN']
            },
            {
                label: 'Licences',
                icon: 'pi pi-key',
                routerLink: ['/licenses'],
                roles: ['ROLE_APP_ADMIN', 'ROLE_ORG_ADMIN']
            },
            {
                label: 'Audit',
                icon: 'pi pi-history',
                routerLink: ['/audit'],
                roles: ['ROLE_APP_ADMIN']
            }
        ]
    }
];
